export const formatPhone = (phone: string) => {
  // Remove all non-digits
  const cleaned = ('' + phone).replace(/\D/g, '');

  // If no valid digits, return the original
  if (!cleaned) return phone;

  // For US numbers, we want 10 digits, trim or pad as needed
  let formattedNumber = cleaned;

  // Remove leading 1 if present (country code)
  if (formattedNumber.startsWith('1') && formattedNumber.length > 1) {
    formattedNumber = formattedNumber.substring(1);
  }

  // If longer than 10 digits, truncate to last 10
  if (formattedNumber.length > 10) {
    formattedNumber = formattedNumber.substring(formattedNumber.length - 10);
  }

  // If we have exactly 10 digits, format nicely
  if (formattedNumber.length === 10) {
    const areaCode = formattedNumber.substring(0, 3);
    const middle = formattedNumber.substring(3, 6);
    const last = formattedNumber.substring(6, 10);
    return `+1 (${areaCode}) ${middle}-${last}`;
  }

  // For shorter numbers, just add a label to show it's incomplete
  return `+1 ${formattedNumber} (incomplete)`;
};
